var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignatureRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "signature (1) 1",
    clipPath: "url(#clip0_13466_8654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Signature"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.62988 16.0928C9.62988 14.6779 10.1919 13.321 11.1924 12.3205L17.0514 6.46155C17.6616 5.85136 18.6509 5.85136 19.2611 6.46155C19.8713 7.07175 19.8713 8.06108 19.2611 8.67124L13.4021 14.5303C12.4016 15.5307 11.0447 16.0928 9.62988 16.0928Z",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.364 10.573L15.1543 8.36328",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.3438 16.9974V17.6562C15.3438 18.5192 14.6442 19.2188 13.7812 19.2188H2.84375C1.98082 19.2188 1.28125 18.5192 1.28125 17.6562V2.34375C1.28125 1.48082 1.98082 0.78125 2.84375 0.78125H11.5715C11.9859 0.78125 12.3834 0.945859 12.6764 1.23891L14.8861 3.44859C15.0765 3.63895 15.2127 3.8734 15.2847 4.12793",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.40625 16.0938C4.40625 15.2308 5.10582 14.5312 5.96875 14.5312C6.83168 14.5312 7.53125 15.2308 7.53125 16.0938H9.62992",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.40625 5.46875H9.09375",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.40625 8.59375H9.09375",
    stroke: "#172B4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13466_8654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureRemove);
export default __webpack_public_path__ + "static/media/signatureRemove.532874c95d17fbde997159c5861a32e9.svg";
export { ForwardRef as ReactComponent };